'use strict';

var React = require('react'),
    AboutSection = require('../organisms/AboutSection'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    AboutSectionCarousel = require('../organisms/AboutSectionCarousel'),
    { PropTypes } = React;

const stampScreenshots = [
  '//stampsy-eu-1.s3.amazonaws.com/uploads/02/19/2015/8bbec3a4-4902-4a03-b186-e43a2cbe8830.jpg',
  '//stampsy-eu-1.s3.amazonaws.com/uploads/02/19/2015/b949b46a-9b34-4a2d-b451-179d2a876206.jpg',
  '//stampsy-eu-1.s3.amazonaws.com/uploads/02/19/2015/f7ec6b00-1ef3-4165-8165-cc10ef29c9e9.jpg',
  '//stampsy-eu-1.s3.amazonaws.com/uploads/02/19/2015/26824141-87d4-4235-b78a-675a2c439801.jpg',
  '//stampsy-eu-1.s3.amazonaws.com/uploads/02/19/2015/0c4a53ad-87c8-4fa9-ad93-6fe742b99e2b.jpg'
];

var AboutStampsSection = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin],

  propTypes: {
    layout: PropTypes.any.isRequired,
    active: PropTypes.bool.isRequired
  },

  statics: {
    backgroundColor: '#FF4081'
  },

  getCSSModifiers() {
    return {
      inactive: !this.props.active
    };
  },

  render() {
    const { active, layout } = this.props;

    return (
      <AboutSection layout={layout}
                    active={active}
                    title='Create beautiful photo stories, mood boards, visual essays and much more. It’s easy and free!'
                    backgroundColor={this.constructor.backgroundColor}
                    color='white'>
        <div className={this.getClassName()}>
          <AboutSectionCarousel type='stamps'
                                active={active}
                                hideScrollbars>
            {stampScreenshots.map((src, index) =>
              <AboutSectionCarousel.Image key={index}
                                          faded={index !== 2}
                                          imageUrl={src}
                                          imageSize={{ width: 330, height: 560 }} />
            )}
          </AboutSectionCarousel>
        </div>
      </AboutSection>
    );
  }
});

module.exports = AboutStampsSection;


/** WEBPACK FOOTER **
 ** ./organisms/AboutStampsSection.jsx
 **/